import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Briefcase, Cpu, BookOpenText } from 'lucide-react';
import { Link } from 'react-router-dom';
export function FacultiesSection() {
  const faculties = [{
    id: 'business',
    icon: <Briefcase className="w-8 h-8" data-id="element-240" />,
    title: 'Faculty of Business and Economics',
    description: 'Fostering future corporate leaders and economic innovators.',
    programs: ['BBA', 'BSS in Economics', 'MBA', 'EMBA'],
    color: 'bg-blue-50',
    accent: 'text-blue-600'
  }, {
    id: 'science',
    icon: <Cpu className="w-8 h-8" data-id="element-241" />,
    title: 'Faculty of Sciences & Engineering',
    description: 'Driving technological advancement through rigorous research.',
    programs: ['B.Sc. in CSE', 'EEE', 'Civil Engineering', 'Pharmacy', 'Data Science'],
    color: 'bg-teal/5',
    accent: 'text-teal',
    link: '/department/cse'
  }, {
    id: 'arts',
    icon: <BookOpenText className="w-8 h-8" data-id="element-242" />,
    title: 'Faculty of Liberal Arts & Social Sciences',
    description: 'Cultivating critical thinkers and societal changemakers.',
    programs: ["LL.B (Hon's)", 'BA in English', 'Sociology', 'Information Studies'],
    color: 'bg-purple-50',
    accent: 'text-purple-600'
  }];
  return <section className="py-24 relative overflow-hidden bg-white" data-id="element-243">
      <div className="max-w-7xl mx-auto px-6" data-id="element-244">
        <div className="text-center max-w-2xl mx-auto mb-16" data-id="element-245">
          <h2 className="text-3xl md:text-4xl font-bold tracking-tight mb-4 text-navy" data-id="element-246">
            Explore Our Faculties
          </h2>
          <p className="text-slate-600 text-lg" data-id="element-247">
            Discover comprehensive academic programs designed to equip you with
            industry-relevant skills and knowledge.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-248">
          {faculties.map((faculty, i) => <motion.div key={faculty.id} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className="bg-white border border-slate-200 shadow-md rounded-2xl p-8 group hover:-translate-y-2 hover:shadow-xl transition-all duration-300 flex flex-col h-full relative overflow-hidden" data-id="element-249">
              {/* Subtle top pastel strip */}
              <div className={`absolute top-0 left-0 right-0 h-32 ${faculty.color} pointer-events-none`} data-id="element-250" />

              <div className={`w-16 h-16 rounded-xl bg-white border border-slate-200 shadow-sm flex items-center justify-center mb-6 ${faculty.accent} relative z-10`} data-id="element-251">
                {faculty.icon}
              </div>

              <h3 className="text-xl font-bold mb-3 relative z-10 text-navy" data-id="element-252">
                {faculty.title}
              </h3>
              <p className="text-sm text-slate-600 mb-8 flex-grow relative z-10" data-id="element-253">
                {faculty.description}
              </p>

              <div className="space-y-2 mb-8 relative z-10" data-id="element-254">
                <div className="text-xs font-bold text-slate-400 uppercase tracking-wider mb-3" data-id="element-255">
                  Featured Programs
                </div>
                {faculty.programs.map((program, idx) => <div key={idx} className="flex items-center text-sm text-slate-700" data-id="element-256">
                    <div className={`w-1.5 h-1.5 rounded-full mr-2 bg-current ${faculty.accent}`} data-id="element-257" />
                    {program}
                  </div>)}
              </div>

              <div className="mt-auto pt-6 border-t border-slate-200 relative z-10" data-id="element-258">
                {faculty.link ? <Link to={faculty.link} className="inline-flex items-center text-sm font-semibold text-navy hover:text-gold transition-colors group/link" data-id="element-259">
                    Explore Departments{' '}
                    <ArrowRight className="w-4 h-4 ml-2 group-hover/link:translate-x-1 transition-transform" data-id="element-260" />
                  </Link> : <a href="#" className="inline-flex items-center text-sm font-semibold text-navy hover:text-gold transition-colors group/link" data-id="element-261">
                    View Fee Structure & Curricula{' '}
                    <ArrowRight className="w-4 h-4 ml-2 group-hover/link:translate-x-1 transition-transform" data-id="element-262" />
                  </a>}
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}